export default __webpack_public_path__ + "static/media/tugo-logo.ccff4715.png";